import { analyticsRef, userStatsRef, logsRef, timestamp, version } from '../config';

function increment(ref, inc = 1) {
  ref.transaction(
    current_value => {
      return (current_value || 0) + inc;
    },
    (error, committed, snap) => {
      if (error) {
        console.log(error.message);
      }
    }
  );
}

export function countLogin(uid, entry) {
  increment(analyticsRef.child('logins'));
  increment(userStatsRef.child(uid).child('logins'));
  userStatsRef.child(uid).update({
    lastActive: timestamp,
    version,
    uid
  });
  if (process.env.NODE_ENV === 'production') {
    logsRef.child('logins').push({
      ts: timestamp,
      uid,
      entry
    });
  }
}

export function countUser(uid) {
  increment(analyticsRef.child('uniques'));
}

export function countSkyscannerClick(data) {
  const { uid } = data;
  userStatsRef.child(uid).child('lastActive').set(timestamp);
  increment(analyticsRef.child('skyscannerClicks'));
  logsRef.child('skyscanner-clicks').push({
    ...data,
    ts: timestamp
  });
}

export function countSearch(uid, data) {
  userStatsRef.child(uid).child('lastActive').set(timestamp);
  logsRef.child('searches').push({
    ...data,
    ts: timestamp,
    uid
  });
}

export function countOrdering(data) {
  userStatsRef.child(data.uid).child('lastActive').set(timestamp);
  logsRef.child('ordering').push({
    ...data,
    ts: timestamp
  });
}



// WEBPACK FOOTER //
// ./src/utils/analyticsUtils.js